import React from 'react';
import { Link } from 'react-router-dom';
import { FaAngleRight } from 'react-icons/fa';

import Item from './Item';
import {
  Container,
  PortfolioContent,
  PortfolioHeader,
  PortfolioListContainer,
  PortfolioList,
  PortfolioNextContainer,
  PortfolioNextButton,
} from './styles';

const Portfolio: React.FC = () => {
  return (
    <Container id="portfolio">
      <PortfolioContent>
        <PortfolioHeader>
          <div>
            <h1>PORTFÓLIO</h1>
          </div>
          <Link to="portfolio">VER TODOS OS PROJETOS</Link>
        </PortfolioHeader>
      </PortfolioContent>

      <PortfolioListContainer>
        <PortfolioList>
          <Item firstTitle="PROJETO" secondTitle="01" />
          <Item firstTitle="PROJETO" secondTitle="02" />
          <Item firstTitle="PROJETO" secondTitle="03" />
          <Item firstTitle="PROJETO" secondTitle="04" />
          <Item firstTitle="PROJETO" secondTitle="05" />
          <Item firstTitle="PROJETO" secondTitle="06" />
          <Item firstTitle="PROJETO" secondTitle="07" />
          <Item firstTitle="PROJETO" secondTitle="08" />
          <Item firstTitle="PROJETO" secondTitle="09" />
          <Item firstTitle="PROJETO" secondTitle="10" />
          <Item firstTitle="PROJETO" secondTitle="11" />
          <Item firstTitle="PROJETO" secondTitle="12" />
          <Item firstTitle="PROJETO" secondTitle="13" />
          <Item firstTitle="PROJETO" secondTitle="14" />
        </PortfolioList>

        <PortfolioNextContainer>
          <PortfolioNextButton>
            <div>NEXT</div>
            <FaAngleRight />
          </PortfolioNextButton>
        </PortfolioNextContainer>
      </PortfolioListContainer>
    </Container>
  );
};

export default Portfolio;
